/**
 * Canonical company logo URL resolver, shared by every stock list (manual
 * portfolios, broker-imported holdings, stock analyses, etc.).
 *
 * Backend-provided `logoURL` values always take priority; this helper is a
 * deterministic fallback so rows with a ticker but no API logo still render
 * the real company logo instead of a single-letter avatar.
 */
export const getStockLogoUrl = (ticker?: string | null): string | undefined => {
  if (!ticker) return undefined;

  const normalized = ticker.trim();
  if (!normalized) return undefined;

  return `https://financialmodelingprep.com/image-stock/${encodeURIComponent(
    normalized.toUpperCase(),
  )}.png`;
};

/**
 * Resolve the best available logo URL for a holding-like object that may or
 * may not have a backend-provided `logoURL`.
 */
export const resolveStockLogoUrl = (
  logoURL?: string | null,
  ticker?: string | null,
): string | undefined => {
  if (logoURL && logoURL.trim()) return logoURL;
  return getStockLogoUrl(ticker);
};
